import ErrorLogger from '../components/ErrorLogger';
import { Font } from 'types/Effects';

const capitalizeWord = (str: string) => {
  // if first char is not a letter
  if (str[0]?.match(/[^A-Za-z0-9]/)) {
    return str[0] + (str[1]?.toUpperCase() || '') + (str.slice(2)?.toLowerCase() || '');
  }

  return (str[0]?.toUpperCase() || '') + (str.slice(1)?.toLowerCase() || '');
};

export const getTransformedText = (transform: string, text: string) => {
  let newText = text;
  switch (transform) {
    case 'capitalize':
      newText = text
        .split(' ')
        .map(
          word =>
            word &&
            word
              .split('\n')
              .map(w => w && capitalizeWord(w))
              .join('\n')
        )
        .join(' ');
      break;
    case 'lowercase':
      newText = text.toLowerCase();
      break;
    case 'uppercase':
      newText = text.toUpperCase();
      break;
    default:
      break;
  }

  return newText;
};

export const fontAlreadyLoaded = (fontFamily: string) => {
  let loaded = false;

  const fonts = document.fonts.values();
  if (!fonts[Symbol.iterator]) return false;

  for (const font of fonts) {
    if (font.family === fontFamily) loaded = true;
  }

  return loaded;
};

export const loadFont = async ({ fontFamily, src }: Partial<Font>) => {
  // We have problem with Montserrat when it is already loaded we need to load it again, cuz the text width is calculated incorrectly
  if (fontFamily !== 'Montserrat' && fontAlreadyLoaded(fontFamily)) return;

  const junctionFont = await new FontFace(fontFamily, `url(${src})`);

  if (!junctionFont.family) {
    return;
  }

  try {
    const loadedFace = await junctionFont.load();
    document.fonts.add(loadedFace);
  } catch (error) {
    ErrorLogger.trigger(error);
    throw new Error(error);
  }
};
